import React from 'react';
import { useTitle } from '../../hook/useTitle';
import { useNavigate } from "react-router-dom";
import { GaleryMansionGrid } from './components/GaleryMansionGrid';

export const Realisation = () => {

    useTitle("Découvrez nos derniers chantiers")

    const navigate = useNavigate();

    const goHome = () => {
        navigate(`/`);
    }

    return (
        <section>
            <main>
                <button
                    className="btn btn-outline btn-sm my-3 ml-2 flex justify-start" onClick={goHome}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
                    </svg>
                    Retour
                </button>
                <h1 className='text-accent font-bold mx-3 py-4 text-left text-4xl'>Découvrez nos derniers chantiers en photos</h1>
                <GaleryMansionGrid />
            </main>
        </section>
    )
}